import { Shield, Clock, Award, Wrench } from "lucide-react";

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Shield,
      title: "Completely Insured for Your Peace of Mind and Protection",
      description: "We ensure your appliances and home are safe during repairs by using protective mats, specialized tools, and maintaining strict adherence to safety protocols throughout the process.",
    },
    {
      icon: Clock,
      title: "Rapid Response Service with Same-Day Availability",
      description: "Our team typically responds within hours, offering same-day service guarantees to handle emergencies swiftly and minimize inconvenience.",
    },
    {
      icon: Award,
      title: "Over 300 Satisfied Clients in the Greater Toronto Area",
      description: "Clients frequently praise our professionalism, promptness, and effective solutions in their reviews.",
    },
    {
      icon: Wrench,
      title: "Highly Skilled Technicians for All Major Appliance Brands",
      description: "Our technicians bring expert experience and specialize in servicing major brands like Whirlpool, Samsung, LG, and Maytag.",
    },
  ];

  return (
    <section className="py-16 bg-[#222222]">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center text-accent hover:text-accent-hover transition-colors">
          Why Choose Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center text-center group transform hover:scale-105 transition-all duration-300">
              <benefit.icon className="w-12 h-12 text-primary mb-4 transform group-hover:scale-110 transition-transform" />
              <h3 className="text-xl font-semibold mb-2 text-accent-light group-hover:text-accent transition-colors">
                {benefit.title}
              </h3>
              <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;